
$(function(){

	// 判断登录状态
	function isLogin(){
		var login = false;
		if (getCookie('DedeUserID') && getCookie('DedeUserID__ckMd5') && getCookie('SESSDATA')) {
			login = true;
		}
		return login;
	}
	// 获取cookie
	function getCookie(name){
		var b, c = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
		return (b = document.cookie.match(c)) ? b[2] : null;
	}

	// 分享窗口
	function openShareWindow(base, param) {
		var temp = [];
		for (var p in param) {
			temp.push(p + '=' + encodeURIComponent(param[p] || ''));
		}
		var _u = base + temp.join('&');
		window.open(_u, '', 'width=700, height=680, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, location=yes, resizable=no, status=no');
		return false;
	}
	// 解析url
	var show_float = true;
	window.__GetUrlValue = function(name) {
	    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	    var r = window.location.search.substr(1).match(reg);
	    if (r != null) {
	        try {
	            return decodeURIComponent(r[2]);
	        } catch(e){
	            return null;
	        }
	    }
	    return null;
	}

	var $STAR = {
		gridPreview:$('.grid-preview'),
		aids:[],
		p1Score:0,
		p2Score:0,
		playList:function(j_data,flag){
			var that = this;
			$.ajax({
				url:j_data,
				type:'get',
				cache:false,
				dataType:'json',
				success:function(data){
					data = data || {};
					var data = data.list || [];
					// data.length = 0;
					data.shuffle();

					// 需要判断小于四的可能性
					function playNull(container){
						if(data.length < 1){
							$(container).addClass('default-hidden');
						} else if(data.length >= 4){
							$(container).siblings('.more-link').removeClass('default-hidden');
						}
					}


					if (flag == 1) {
						var container = '.left-cont .video-cont',
							voteId = voteId1;
						playNull(container);
					}else{
						var container = '.right-cont .video-cont',
							voteId = voteId2;
						playNull(container);
					}

					getFourList(container);
					function getFourList(container){
						that.totalScore(container,data);
						that.getFavour(container);

						$(container).empty();
						for(var i = 0; i < 4 ; i++) {
							if(!data[i]){
					    		break;
					    	}else{
					            var scoreWrapper = $('<div class="score-wrapper clearfix" id='+data[i].number+'><a class="score-icon"></a><a class="score-icon"></a><a class="score-icon"></a><a class="score-icon"></a><a class="score-icon"></a></div>');
					            var scoreBlock = $('<input type="text" class="vote-value" value="0"/>');

					            var tmepBlock = '<div class="tp-zp" data-aid="'+data[i].aid+'">' +
									'<div class="img-result" data-src="' + data[i].litpic + '" style="background-image: url(' + data[i].litpic + ');"></div>' +
					                '<div class="t" title="'+data[i].title+'">'+data[i].title+'</div></a>' +
					                '<div class="rate">' +
					                '<div class="pf"><div class="bra"></div><a class="btn" aid="'+data[i].aid+'">评分</a></div>'+
					                '<div class="share-btn">分享</div>'+
					                '</div>';

								//判断是否已评分,确定第一个参数在数组中的位置，如果没有找到则返回-1
								if($.inArray(data[i].aid.toString(), that.aids) >=0) {
									// 隐藏评分那行和评分按钮，显示出分享按钮
									$('.score-wrapper,.pf').css('display', 'none');
									$('.share-btn').css('display', 'block');
								}else{
									// 显示评分那行和评分按钮，隐藏出分享按钮
									// $('.score-wrapper,.pf').css('display', 'block');
									// $('.share-btn').css('display', 'none');
								}
								var block = $(tmepBlock);
								block.appendTo($(container));
								scoreWrapper.appendTo(block.find('.rate'));
								scoreBlock.appendTo(block.find('.bra'));
								that.getScore(scoreWrapper,scoreBlock);
					    	}

						}
						// 整页面评分和点击弹窗及其分享自动弹窗
						that.getVote(container);
						that.bigVideo(container);

						$(container).find('.share-btn').off().on('click',function(){
							var share_aid = $(this).parents('.tp-zp').attr('data-aid');
							var share_src = $(this).parents('.tp-zp').find('.img-result').attr('data-src');
							if(container == '.left-cont .video-cont'){
								var share_txt = '去了！我喜欢的厂商、游戏出席TGS东京电玩展了！我好兴奋啊！！快来给视频评分投票，展现一波信仰的力量！';
							}else{
								var share_txt = '没去？没在TGS东京电玩展看到喜欢的游戏和厂商诶…没关系，来看应援视频，给喜欢的游戏投票评分！咱们也能玩很high嘛~';
							}
							that.shareVideo(share_aid,share_src,share_txt);
						})

						that.autoVideo(data,container);
					}

				}
			})
		},
		// 对决总分获取
		totalScore:function(container,lists){
			var that = this;
			// 遍历所有视频的票数
			var total = 0, scroe = 0;
			for (var i = 0; i < lists.length; i++) {
				score = parseInt(lists[i].total_scores);
				total += score;
			}

			if(container =='.left-cont .video-cont'){
				that.p1Score = total;
				$('.tgs-vs .vs-left .num').text(that.p1Score);
			}else{
				that.p2Score = total;
				$('.tgs-vs .vs-right .num').text(that.p2Score);
			}

			// console.log(that.p1Score,that.p2Score);
			if(that.p1Score != 0 || that.p2Score != 0){
				that.moveTicket(that.p1Score, that.p2Score);
			}

		},
		// 获取用户已经评过分的视频aid
		getFavour:function(container){
			var that = this;
			if(container =='.left-cont .video-cont'){
				var voteId = voteId1;
			}else{
				var voteId = voteId2;
			}
			var myvote = 'http://www.bilibili.com/plus/mission_vote.php?msid='+voteId+'&act=get_my_vote_scores';
			$.ajax({
				url: myvote,
				type:'get',
				cache: false,
				dataType:'json',
				async: false,
				success:function(data){
					that.aids = data.aids || [];

				}
			})

		},
		// 悬浮点击效果及分数
		getScore:function(scoreWrapper,scoreBlock){
			scoreWrapper.find("a").hover(
			    function(){
			        if(scoreWrapper.find('a[hasmessagebox="yes"]').length>0){
			            return;
			        }
			        var btn = $(this);
			        var index = btn.index();
			        scoreWrapper.find("a:lt("+(index+1)+")").addClass("on");
			        scoreWrapper.find("a:gt("+(index)+")").removeClass("on");
			    },
			    function(){
			        if(scoreWrapper.find('a[hasmessagebox="yes"]').length>0){
			            return;
			        }
			        var btn = $(this);
			        var index = btn.index();
			        if(index==0){
			            scoreWrapper.find("a").removeClass("on");
			        }
			    }
			);
			scoreWrapper.find("a").on("mouseleave",function(){
				scoreWrapper.find("a").removeClass("on");
			})

			scoreWrapper.find("a").click(
			    function(){
			        if(scoreWrapper.find('a[hasmessagebox="yes"]').length>0){
			            return;
			        }
			        var btn = $(this);
			        var index = btn.index();
			        scoreWrapper.find("a:lt("+(index+1)+")").addClass("active");
			        scoreWrapper.find("a:gt("+(index)+")").removeClass("active");
			        var rateScore = (index+1)*2;
			        scoreBlock.attr('value',rateScore)
			    }
			);

		},
		// 整个页面评分
		getVote:function(container){
			var that = this;
			$(container).find('.tp-zp .rate .btn').off().click(function(){
				if(!isLogin()){
					biliQuickLogin(function() {
						window.location.reload();
					});
				}else{

					if(container == '.left-cont .video-cont'){
						voteId = voteId1;
					}else{
						voteId = voteId2;
					}

					var sf = this;
					var aid = $(sf).attr("aid");
					var val = parseInt($(sf).parent().find(".vote-value").val());

					if(!val){
						new MessageBox({ Overlap:true}).show(sf,'评分数量不正确',2000,'error');
						return false;
					}
					var msgbox = new MessageBox().show(this,'确认对此视频进行评分？','button',function(mobj){
					    $.ajax({
					    	url:"http://www.bilibili.com/m/mission_vote?aid="+aid+"&msid="+voteId+"&vote="+val,
	                        headers: {
	                            // 请求头缓存设置，避免浏览器缓存。仅对 XMLHttpRequest 请求有效
	                            // script、jsonp 并不是真正的 XMLHttpRequest 请求，所以这个不适用这两种类型
	                            'Cache-Control': 'no-cache',    // HTTP/1.1
	                            'Pragma': 'no-cache',           // HTTP/1.0
	                            'Expires': '-1'                 // Proxy
	                        },
	                        cache: true, // 不要添加时间戳，避免穿透 CDN 缓存
					        success:function(data){
					            switch(data){
					                case "-1": new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'不在可评分时间内',2000,'error'); break;
					                case "-2": new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'评分的视频不存在',2000,'error'); break;
					                case "-3": new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'您已经对此视频评过分',2000,'error'); break;
					                case "-4": new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'您所属的IP评分过于频繁',2000,'error'); break;
					                case "-5": new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'评分数量不正确',2000,'error'); break;
					                case "-6": new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'请登录符合评分的账号',2000,'error'); break;
					                case "-7": new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'您剩余的可评分点数不足',2000,'error'); break;
					                case "0":
					                	new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'评分成功',1000,'ok');
										$(sf).parents('.pf').addClass('default-hidden');
										$(sf).parents('.tp-zp').find('.score-wrapper').addClass('default-hidden');
										$(sf).parents('.tp-zp').find('.share-btn').css('display', 'block');

										var p1DateScore = parseInt($('.tgs-vs .vs-left .num').text());
										var p2DateScore = parseInt($('.tgs-vs .vs-right .num').text());
										if(voteId == voteId1){
											// 给去了加分
											p1DateScore += val;
											that.moveTicket(p1DateScore, p2DateScore);

										}else{
											//给没去加分
											p2DateScore += val;
											that.moveTicket(p1DateScore, p2DateScore);

										}

					                	break;
					                default:new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'未知错误：'+data,2000,'error');
					            }
					        },
					        error:function(){
					            new MessageBox({ Overlap:true,position:mobj.position}).show(sf,'提交失败',2000,'error');
					        }
					    });
					});
				}
			})
		},
		// 点击显示弹窗视频
		bigVideo:function(container){
			var that = this;
			$(container).find(".tp-zp > .img-result").off().click(function(){
				var $that = $(this).parent('.tp-zp'),
					videoId = $that.attr('data-aid'),
					src = $that.find('.img-result').attr('data-src'),
					txt = $that.find('.t').text();

				that.showVideo(container,videoId,src,txt);
			})
		},
		// 显示弹窗视频且可以评分
		showVideo:function(container,videoId,src,txt){
			var that = this;
			// 更新已评分的数组aids
			that.getFavour(container);
			console.log(that.aids);
			if($.inArray(videoId.toString(), that.aids) >=0) {
				that.gridPreview.find('.video-right').css('display', 'none');
			}else{
				that.gridPreview.find('.video-right').css('display', 'block');
			}

			var	ifr_video = '<iframe id="bofqi_embed" style="width:100%;height:100%;border:none;overflow: no-scroll;" src="http://www.bilibili.com/html/player.html?aid='+ videoId +'&autoplay=1&as_wide=1&wmode=transparent" wmode="transparent" scrolling="no" border="0" frameborder="no" framespacing="0" onload="window.securePlayerFrameLoaded=true"></iframe>';

			that.gridPreview.attr({
				'data-aid':videoId,
				'data-src': src
			});
			that.gridPreview.find('.title-name').text(txt);
			that.gridPreview.find('.video').empty().append($(ifr_video));
			that.gridPreview.find('.drawyoo-space').attr('href', "http://www.bilibili.com/video/av"+ videoId +"/");
			that.gridPreview.find('.video-state .btn').attr('aid', videoId);
			that.gridPreview.find('.vote-value').attr('value', '0');
			that.gridPreview.fadeIn(0);

			var scoreWrapper = $('.score-big-wrapper');
			var scoreBlock = $('.video-state .bra input');
			that.getScore(scoreWrapper,scoreBlock);
			that.gridPreview.find(".video-state .btn").off().click(function(){
				if(!isLogin()){
					biliQuickLogin(function() {
						window.location.reload();
					});
				}else{

					if(container == '.left-cont .video-cont'){
						voteId = voteId1;
					}else{
						voteId = voteId2;
					}

					var sf = this;
					var aid = $(sf).attr("aid");
					var val = parseInt($(sf).parent().find(".vote-value").val());

					if(!val){
						new MessageBox({ Overlap:true}).show(sf,'评分数量不正确',2000,'error');
						return false;
					}
					$.ajax({
						url:"http://www.bilibili.com/m/mission_vote?aid="+aid+"&msid="+voteId+"&vote="+val,
                        headers: {
                            // 请求头缓存设置，避免浏览器缓存。仅对 XMLHttpRequest 请求有效
                            // script、jsonp 并不是真正的 XMLHttpRequest 请求，所以这个不适用这两种类型
                            'Cache-Control': 'no-cache',    // HTTP/1.1
                            'Pragma': 'no-cache',           // HTTP/1.0
                            'Expires': '-1'                 // Proxy
                        },
                        cache: true, // 不要添加时间戳，避免穿透 CDN 缓存
					    success:function(data){
					        switch(data){
					            case "-1": new MessageBox({ Overlap:true}).show(sf,'不在可评分时间内',2000,'error'); break;
					            case "-2": new MessageBox({ Overlap:true}).show(sf,'评分的视频不存在',2000,'error'); break;
					            case "-3": new MessageBox({ Overlap:true}).show(sf,'您已经对此视频评过分',2000,'error'); break;
					            case "-4": new MessageBox({ Overlap:true}).show(sf,'您所属的IP评分过于频繁',2000,'error'); break;
					            case "-5": new MessageBox({ Overlap:true}).show(sf,'评分数量不正确',2000,'error'); break;
					            case "-6": new MessageBox({ Overlap:true}).show(sf,'请登录符合评分的账号',2000,'error'); break;
					            case "-7": new MessageBox({ Overlap:true}).show(sf,'您剩余的可评分点数不足',2000,'error'); break;
					            case "0":
					            	new MessageBox({ Overlap:true}).show(sf,'评分成功',1000,'ok');

					            	that.gridPreview.find('.video-right').css('display', 'none');
									// 找到页面中已评分的视频aid
									var tp_zp= $(container).find('.tp-zp[data-aid=' + aid + ']');
									tp_zp.find('.pf').addClass('default-hidden');
									tp_zp.find('.score-wrapper').addClass('default-hidden');
									tp_zp.find('.share-btn').css('display', 'block');

									var p1DateScore = parseInt($('.tgs-vs .vs-left .num').text());
									var p2DateScore = parseInt($('.tgs-vs .vs-right .num').text());
									if(voteId == voteId1){
										// 给去了加分
										p1DateScore += val;
										that.moveTicket(p1DateScore, p2DateScore);
									}else{
										//给没去加分
										p2DateScore += val;
										that.moveTicket(p1DateScore, p2DateScore);
									}

					            	break;
					            default:new MessageBox({ Overlap:true}).show(sf,'未知错误：'+data,2000,'error');
					        }
					    },
					    error:function(){
					        new MessageBox({ Overlap:true}).show(sf,'提交失败',2000,'error');
					    }
					});
				}
			});

			that.gridPreview.find('.video-share').off().on('click',function(){
				var share_aid = that.gridPreview.attr('data-aid');
				var share_src = that.gridPreview.attr('data-src');
				if(container == '.left-cont .video-cont'){
					var share_txt = '去了！我喜欢的厂商、游戏出席TGS东京电玩展了！我好兴奋啊！！快来给视频评分投票，展现一波信仰的力量！';
				}else{
					var share_txt = '没去？没在TGS东京电玩展看到喜欢的游戏和厂商诶…没关系，来看应援视频，给喜欢的游戏投票评分！咱们也能玩很high嘛~';
				}
				that.shareVideo(share_aid,share_src,share_txt);
			})

			that.closeItem();
		},
		//分享
		shareVideo:function(pid,pic,txt){
			var that = this;
		    openShareWindow('http://service.weibo.com/share/share.php?', {
		        url: shareUrl+'?pid='+pid,
		        type: '3',
		        count: '1',
		        /**是否显示分享数，1显示(可选)*/
		        appkey: '2841902482',
		        /**您申请的应用appkey,显示分享来源(可选)*/
		        title: txt,
		        /**分享的文字内容(可选，默认为所在页面的title)*/
		        pic: pic,
		        /**分享图片的路径(可选)*/
		        searchPic: 'false',
		        ralateUid: '',
		        /**关联用户的UID，分享微博会@该用户(可选)*/
		        language: 'zh_cn',
		        /**设置语言，zh_cn|zh_tw(可选)*/
		        rnd: new Date().valueOf()
		    });
		},
		// 解析url餐数自动弹出视频播放
		autoVideo:function(lists,container){
			var that = this;
			if(__GetUrlValue('pid') && show_float) {
			    show_float = false;
				var videoId = __GetUrlValue('pid');
				var src,txt;
				// 根据视频aid遍历获取对应的图片src和txt
				for (var i = 0; i < lists.length; i++) {
					if (lists[i].aid == videoId) {
						src = lists[i].litpic;
						txt = lists[i].title;
					}
				}
				that.showVideo(container,videoId,src,txt);

			}
		},
		closeItem:function(){
			var that = this;
			$('#item-close').click(function() {
			    that.gridPreview.find('.video').empty();
			    that.gridPreview.find('.score-big-wrapper a').removeClass('active');
			    that.gridPreview.fadeOut(0);
			});
		},
		vsIcon:function(){
			var p1DateScore = parseInt($('.tgs-vs .vs-left .num').text());
			var p2DateScore = parseInt($('.tgs-vs .vs-right .num').text());

			if(p1DateScore>p2DateScore){
				$('.tgs-vs .vs-left .icon').removeClass('on');
				$('.tgs-vs .vs-right .icon').addClass('on');
			}else{
				$('.tgs-vs .vs-left .icon').addClass('on');
				$('.tgs-vs .vs-right .icon').removeClass('on');
			}

		},
		moveTicket:function(p1DateScore,p2DateScore){
			var that = this;
			if(!p1DateScore){
				p1DateScore = 0;
			}
			if(!p2DateScore){
				p2DateScore = 0;
			}

			var allScore = p1DateScore + p2DateScore;

			$('.tgs-vs .vs-left .num').text(p1DateScore);
			$('.tgs-vs .vs-right .num').text(p2DateScore);
			that.vsIcon();

            if(p1DateScore == 0 && p2DateScore == 0){
                $('.vote-left').stop().animate({'width':'50%'},500)
            }else if(p1DateScore == 0){
                $('.vote-left').stop().animate({'width':0},500,function(){
                    $('.vote-left').hide();
                    $('.bar-scale').hide();
                })
            }else if(p2DateScore == 0){
                $('.vote-left').stop().animate({'width':'100%'},500,function(){
                    $('.bar-scale').hide();
                })
            }else{
                $('.vote-left').show();
                $('.bar-scale').show();
                $('.vote-left').stop().animate({'width':p1DateScore/allScore*100 + '%'},800);
            }

		},
		// 点击嘉宾区轮播图显示弹窗
		sliderVideo:function(){
			var that = this;
			$('.tgs-contain .guest-part .guest .slider-ul li img').off().click(function(){
				var videoId = $(this).attr('data-aid'),
					src = $(this).attr('src'),
					txt = $(this).siblings('.intro').find('.video-name').text();

				var	ifr_video = '<iframe id="bofqi_embed" style="width:100%;height:100%;border:none;overflow: no-scroll;" src="http://www.bilibili.com/html/player.html?aid='+ videoId +'&autoplay=1&as_wide=1&wmode=transparent" wmode="transparent" scrolling="no" border="0" frameborder="no" framespacing="0" onload="window.securePlayerFrameLoaded=true"></iframe>';

					that.gridPreview.attr({
						'data-aid':videoId,
						'data-src': src
					});
					that.gridPreview.find('.title-name').text(txt);
					that.gridPreview.find('.video').empty().append($(ifr_video));
					that.gridPreview.find('.drawyoo-space').attr('href', "http://www.bilibili.com/video/av"+ videoId +"/");
					that.gridPreview.find('.video-right').css('display', 'none');
					that.gridPreview.fadeIn(0);

					that.gridPreview.find('.video-share').off().on('click',function(){
						var share_aid = '';
						var share_src = that.gridPreview.attr('data-src');
						var share_txt = '去了没去-东京电玩展2016】你喜欢的厂商爸爸们参展了么？不管他们去了没去，这里都有一个机会给你喜欢的游戏应援！快来看看吧~';
						that.shareVideo(share_aid,share_src,share_txt);
					})
			})

			$('.about-part .slider-ul li .slider-box .slider-img').off().click(function(){
				var videoId = $(this).attr('data-aid'),
					src = $(this).attr('src'),
					txt = $(this).parent('.slider-box').find('.slider-p').text();

				var	ifr_video = '<iframe id="bofqi_embed" style="width:100%;height:100%;border:none;overflow: no-scroll;" src="http://www.bilibili.com/html/player.html?aid='+ videoId +'&autoplay=1&as_wide=1&wmode=transparent" wmode="transparent" scrolling="no" border="0" frameborder="no" framespacing="0" onload="window.securePlayerFrameLoaded=true"></iframe>';

					that.gridPreview.attr({
						'data-aid':videoId,
						'data-src': src
					});
					that.gridPreview.find('.title-name').text(txt);
					that.gridPreview.find('.video').empty().append($(ifr_video));
					that.gridPreview.find('.drawyoo-space').attr('href', "http://www.bilibili.com/video/av"+ videoId +"/");
					that.gridPreview.find('.video-right').css('display', 'none');
					that.gridPreview.fadeIn(0);

					that.gridPreview.find('.video-share').off().on('click',function(){
						var share_aid = '';
						var share_src = that.gridPreview.attr('data-src');
						var share_txt = '去了没去-东京电玩展2016】你喜欢的厂商爸爸们参展了么？不管他们去了没去，这里都有一个机会给你喜欢的游戏应援！快来看看吧~';
						that.shareVideo(share_aid,share_src,share_txt);
					})
			})

			that.closeItem();
		},
		//直播区域
		liveNow:function(){
			$.ajax({
				url: 'http://www.bilibili.com/index/promote/63.json',
				type: 'get',
				dataType: 'json',
				async:false,
				success : function(data){
					var item = data.item || {};
					var liveId = item[0].width;
					var liveTxt = item[0].title;
					var liveRoom = $("#living-now");
					var str = $('<div class="embed_box" style="width: 1000px;height: 565px;position: relative;margin: 0 auto;">'
					        +'<object type="application/x-shockwave-flash" data="http://static.hdslb.com/live-static/swf/LivePlayerEx_1.swf" width="100%" height="100%" id="player_object" style="visibility: visible;">'
					        +'<param name="allowfullscreeninteractive" value="true">'
					        +'<param name="allowfullscreen" value="true">'
					        +'<param name="quality" value="high">'
					        +'<param name="allowscriptaccess" value="always">'
					        +'<param name="wmode" value="transparent">'
					        +'<param name="flashvars" value="onready=playerOnReady&room_id='+ liveId +'&sch_id=7564&meta_id=44860&cid='+ liveId +'&start=1430349501&cover=http://cn-live1.baka.im/shoot/live_9918434_332_c521e483.jpg&state=LIVE">'
					        +'</object>'
					        +'</div>');

					if(liveTxt){
						$('.zhibo-title').text(liveTxt);
					}else{
						$('.zhibo-title').css('display', 'none');
					}
					if(liveId){
						liveRoom.empty();
						liveRoom.append(str);
						$('.living-go a').attr('href', 'http://live.bilibili.com/'+liveId+'');
						$('.zhibo-part').css('display', 'block');

						$('.about-video').addClass('now');

						$('.send-button').on('click',function(){
							if(!isLogin()){
								biliQuickLogin(function() {
									window.location.reload();
								});
							}else{
								var val = $('.send input').val()
		                        if($.trim(val) == ''){
		                            new MessageBox().show($('.send-button'), '请输入正确内容！', 1200);
		                            return false;
		                        }else{
		                            $('#living-now').find('#player_object')[0].sendMsg(val);
		                            $('.send input').val('');
		                        }

							}
						})

			            $(document).keypress(function(e) {
			                // 回车键事件
			                if(e.which == 13) {
			                    $('.send-button').click();
			                }
			            });

					}else{
						$('.zhibo-part').css('display', 'none');
					}


				}
			})
		},
		init:function(){
			var that = this;
			that.playList('http://www.bilibili.com/list/vote/'+voteId1+'.json',1);
			that.playList('http://www.bilibili.com/list/vote/'+voteId2+'.json',2);
			that.sliderVideo();
			that.liveNow();
		}
	};
	$STAR.init();


})


/** WEBPACK FOOTER **
 ** ./src/js/compontents/tgs.js
 **/